export default __webpack_public_path__ + "static/media/shopping.fb135b0b.svg";